import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  userEntersFirstName,
  UserEntersFirstName,
  userEntersLastName,
  UserEntersLastName
} from '../actions/Actions';
import { IState, IUserInfo } from '../CustomTypes';
import { validateName } from '../validators';
import {
  classNames,
  Display,
  FlexDirection,
  FontSize,
  Margin,
  TextColor
} from '@snoam/pinata';
import { InputField } from './InputComponents';

export interface IActionProps {
  userEntersFirstName: UserEntersFirstName;
  userEntersLastName: UserEntersLastName;
}

export interface IParamProps {
  initialFocus?: boolean;
  formSubmitted?: boolean;
}

export interface IStateProps {
  userInfo: IUserInfo;
}

export interface IProps extends IParamProps, IStateProps, IActionProps {
  noLabel?: boolean;
}

const styleClass = {
  error: classNames(
    TextColor.TEXT_NEGATIVE,
    FontSize.TEXT_SM,
    Margin.MT_NEGATIVE_4,
    Margin.MB_4
  ),
  firstName: classNames(Margin.MR_2,),
  inputGroup: classNames(Display.FLEX, FlexDirection.FLEX_ROW),
  root: classNames(Display.FLEX, FlexDirection.FLEX_COL)
};

export class Name extends React.Component<
  IProps,
  { showValidationError: boolean }
> {
  constructor(props: IProps) {
    super(props);
    this.onBlur = this.onBlur.bind(this);
    this.isValid = this.isValid.bind(this);
    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.state = { showValidationError: false };
  }

  public componentDidUpdate(prevProps: Readonly<IProps>): void {
    if (
      prevProps.formSubmitted !== this.props.formSubmitted &&
      this.props.formSubmitted
    ) {
      if (!this.isValid()) {
        this.setState({
          showValidationError: true
        });
      }
    }
  }

  public render() {
    const { firstName, lastName } = this.props.userInfo;
    const { initialFocus, formSubmitted } = this.props;
    const validationErrorMessage = 'Du kan kun bruke bokstaver, tall og mellomrom.';
    

    const showValidationError =
    (formSubmitted || this.state.showValidationError) && !this.isValid();
    
    return (
      <div className={styleClass.root}>
        <div className={styleClass.inputGroup}>
          <span className={styleClass.firstName}>
            <InputField
              value={firstName}
              initialFocus={initialFocus}
              type={'text'}
              onChange={e => this.handleFirstNameChange(e.currentTarget.value)}
              label={"Fornavn"}
              maxLength={200}
              validationErrorMessage={" "}
              validator={e => validateName(e) && !showValidationError}
            />
          </span>

          <InputField
            value={lastName}
            type={'text'}
            onChange={e => this.handleLastNameChange(e.currentTarget.value)}
            label="Etternavn"
            maxLength={200}
            validationErrorMessage={" "}
            validator={e => validateName(e) && !showValidationError}
            onBlur={this.onBlur}
          />
        </div>

        {showValidationError && (
          <div className={styleClass.error}>{validationErrorMessage}</div>
        )}
      </div>
    );
  }

  private handleFirstNameChange(value: string) {
    if (this.isValid()) {
      this.setState({ showValidationError: false });
    }

    this.props.userEntersFirstName(value)
  }

  private handleLastNameChange(value: string) {
    if (this.isValid()) {
      this.setState({ showValidationError: false });
    }
    this.props.userEntersLastName(value);
  }

  private onBlur() {
    this.setState({ showValidationError: !this.isValid() });
  }

  private isValid(): boolean {
    const { firstName, lastName } = this.props.userInfo;
    return validateName(firstName) && validateName(lastName);
  }
}

export default connect(
  (state: IState) =>
    ({
      userInfo: state.userInfo
    } as IStateProps),
  dispatch =>
    bindActionCreators(
      {
        userEntersFirstName,
        userEntersLastName
      },
      dispatch
    ) as IActionProps
)(Name);
